import React, { useState } from 'react';
import Image from 'antd/lib/image';
import { EyeOutlined } from '@ant-design/icons';

interface Props {
    src: string | null;
    className: string;
    // the full-size image: the thumb opens it in an overlay
    fullSrc?: string | null;
}

// Previews are copied in the background after a search, so a first load can 404;
// the failure is remembered per mount only, so reopening tries again.
export default function LibraryThumb(props: Props): JSX.Element {
    const { src, className, fullSrc } = props;
    const [failedSrc, setFailedSrc] = useState<string | null>(null);

    if (!src || failedSrc === src) {
        return <div className={`${className} cvat-references-crop-placeholder`} />;
    }
    if (fullSrc) {
        return (
            // the overlay opens on click: the row behind must not take it as a selection
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <span className='cvat-references-zoom' onClick={(event) => event.stopPropagation()}>
                {/* the eye alone: antd's "Preview" caption is cut to an ellipsis on a small thumb */}
                <Image
                    className={className}
                    src={src}
                    alt=''
                    preview={{ src: fullSrc, mask: <EyeOutlined /> }}
                    onError={() => setFailedSrc(src)}
                />
            </span>
        );
    }
    return <img className={className} src={src} alt='' onError={() => setFailedSrc(src)} />;
}
